export function License({
    id,
    uid,
    status,
    createdOn,
    validUntil,
    cancelledOn,
    renewalNoticeSentOn,
    quantity,
    licenseTypeUID,
    locationUID,
    locationName,
    locationOwnerEmail,
    renewalCount,
    renewalPeriodStarts,
    licenseTypeName,
    own,
} = {}) {
    return {
        id,
        uid,
        status,
        createdOn,
        validUntil,
        cancelledOn,
        renewalNoticeSentOn,
        quantity,
        licenseTypeUID,
        locationUID,
        locationName,
        locationOwnerEmail,
        renewalCount,
        renewalPeriodStarts,
        licenseTypeName,
        own,
    };
}
